import { SelectOptions } from '@/model/CommonModel';
import { Dropdown, MenuProps } from 'antd';
import React from 'react';
import styles from './contextMenu.module.scss';

export type ContextMenuProps<T> = {
	className?: string;
	options?: SelectOptions<T>[];
	onClickOption?: (value: T) => void;
	children?: JSX.Element;
	menuId?: string;
	destroyPopupOnHide?: boolean;
	open?: boolean;
	onOpenChange?: (open: boolean, info: { source: 'trigger' | 'menu' }) => void;
	style?: React.CSSProperties;
};

export const ContextMenu: React.FC<ContextMenuProps<number>> = <T extends {}>({
	className,
	options,
	onClickOption,
	onOpenChange,
	children,
	destroyPopupOnHide,
	open,
	style,
}: ContextMenuProps<T>) => {
	const items: MenuProps['items'] = options.map(({ label, disabled, title, icon, id, separator, value, key }, index) => {
		let newKey = `${label}-${index}`;
		if (key) {
			newKey = `${newKey}-${key}`;
		}

		return {
			id,
			key: newKey,
			onClick: e => {
				e.domEvent.stopPropagation();
				onClickOption?.(value);
			},
			className: separator ? styles.separator : undefined,
			disabled,
			title,
			icon,
			label,
		};
	});

	return (
		<Dropdown
			menu={{ items }}
			trigger={['contextMenu']}
			destroyPopupOnHide={destroyPopupOnHide}
			open={open}
			onOpenChange={onOpenChange}
			overlayStyle={{ width: 'max-content', ...style }}
			overlayClassName={className}
		>
			{children}
		</Dropdown>
	);
};
